
import { Component, Prop, Vue } from 'vue-property-decorator';  
import "@/store/modules/application";

import UnderlineForm from "@/components/utils/PopulateForms/components/UnderlineForm.vue";
import CheckBox from "@/components/utils/PopulateForms/components/CheckBox.vue";
import { schedule3DataInfoType } from '@/types/Application/CaseManagement/PDF';

@Component({
    components:{
        UnderlineForm,
        CheckBox
    }
})
export default class Schedule3 extends Vue {

    @Prop({required:true})
    result!: any;
   
    dataReady = false;   
    modReqInfo = {} as schedule3DataInfoType;
   
    mounted(){
        this.dataReady = false;
        this.extractInfo();       
        this.dataReady = true;
    } 

   
    public extractInfo(){
        this.modReqInfo = this.getWaiveModifyAnyOtherRequirementsInfo();
    }

    public getWaiveModifyAnyOtherRequirementsInfo(){
        
        let waiveModifyAnyOtherRequirementsInfo = {} as schedule3DataInfoType;
        
        if(this.result?.changingOrCancellingAnyOtherRequirementSurvey){

            const chgSurvey = this.result.changingOrCancellingAnyOtherRequirementSurvey;
                
            waiveModifyAnyOtherRequirementsInfo.appliedRequirementsList = chgSurvey.appliedRequirementsList? chgSurvey.appliedRequirementsList: [];
            waiveModifyAnyOtherRequirementsInfo.appliedRequirementsListComment = chgSurvey.appliedRequirementsListComment? chgSurvey.appliedRequirementsListComment: '';
            waiveModifyAnyOtherRequirementsInfo.orderDetail = chgSurvey.orderDetail? chgSurvey.orderDetail: '';            
            waiveModifyAnyOtherRequirementsInfo.applicationFacts = chgSurvey.applicationFacts ? chgSurvey.applicationFacts:'';
            waiveModifyAnyOtherRequirementsInfo.dateOfOrder = waiveModifyAnyOtherRequirementsInfo.appliedRequirementsList.includes('Time limit set by an order or direction of a judge')? Vue.filter('beautify-date-blank')(chgSurvey.dateOfOrder):'' 
            waiveModifyAnyOtherRequirementsInfo.judgeName = waiveModifyAnyOtherRequirementsInfo.appliedRequirementsList.includes('Time limit set by an order or direction of a judge')? chgSurvey.judgeName: ''
        }

        return waiveModifyAnyOtherRequirementsInfo
    } 

}
